import React, { Component } from "react";
import { NavLink } from "react-router-dom";

class CompareButton extends Component {
    render() {
        const { to = "", noLink, className = "" } = this.props;
        const Tag = noLink ? "div" : NavLink;

        return (
            <Tag className={`button compare-button secondary ${className}`} {...(noLink ? { href: to } : { to })}>
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.5 19.9902L7.44625 18.9212L10.2808 16.0865H3V14.5865H10.2808L7.44625 11.752L8.5 10.6828L13.1538 15.3365L8.5 19.9902ZM16.5 14.3077L11.8463 9.65375L16.5 5L17.5538 6.06925L14.7193 8.904H22V10.4038H14.7193L17.5538 13.2385L16.5 14.3077Z" fill="#009FE3"/>
                </svg>
                <strong>Compare</strong>
            </Tag>
        );
    }
}

export default CompareButton;